import React, { useState } from "react";
import { connect } from "react-redux";
import { Menu, Layout,Dropdown,Typography } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, CaretDownFilled } from '@ant-design/icons';
import Logo from './Logo';
import NavProfile from './NavProfile';
import NavSearch  from './NavSearch';
import { toggleCollapsedNav, onMobileNavToggle } from 'redux/actions/Theme';
import { changeLocation } from 'redux/actions/main';
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from 'constants/ThemeConstant';
import utils from 'utils'
import { Link } from "react-router-dom";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";

const { Header } = Layout;
const {Text} = Typography;
export const HeaderNav = props => {
  const { 
    navCollapsed, 
    mobileNav, 
    navType, 
    headerNavColor, 
    toggleCollapsedNav, 
    onMobileNavToggle, 
    isMobile,
    organization, 
    location, 
    locations,
    changeLocation,
    headerNavExpand
  } = props;

  const [searchActive, setSearchActive] = useState(false);
  const history = useHistory();
  const onSearchActive = () => {
    setSearchActive(true);
  };

  const onSearchClose = () => {
    setSearchActive(false)
  }

  const onToggle = () => {
    if(!isMobile) {
      toggleCollapsedNav(!navCollapsed)
    } else {
      onMobileNavToggle(!mobileNav)
    }
  }

  const handleCurrentLocation = (e) => {
    localStorage.setItem('LOCATION_ID', e.key)
    changeLocation({
      id: e.key,
      name: e.item.props.name
    })
    history.push(
      `/app/Dashboard`
    )
  }

  const locationList = (
    <Menu onClick={handleCurrentLocation}>
      {locations?.map((elm) => {
        return <Menu.Item key={elm.id} name={elm.name}>
        {elm.name}
      </Menu.Item>
      })}
    </Menu>
  );

  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  const mode = utils.getColorContrast(headerNavColor)
  const getNavWidth = () => {
    if(isNavTop || isMobile) {
      return '0px'
    }
    if(navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`
    } else {
      return `${SIDE_NAV_WIDTH}px`
    }
  }
  return (
    <Header
      className={`app-header ${mode}`}
      style={{ backgroundColor: headerNavColor }}
    >
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={mode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          {headerNavExpand && (
            <div className="nav-left">
              <Menu mode="horizontal">
                {isNavTop && !isMobile ? null : (
                  <Menu.Item
                    key="0"
                    onClick={() => {
                      onToggle();
                    }}
                  >
                    {navCollapsed || isMobile ? (
                      <MenuUnfoldOutlined className="nav-icon" />
                    ) : (
                      <MenuFoldOutlined className="nav-icon" />
                    )}
                  </Menu.Item>
                )}
                {
                  // isMobile ?
                  // <Menu.Item key="1" onClick={() => {onSearchActive()}}>
                  //   <SearchOutlined />
                  // </Menu.Item>
                  // :
                  // <Menu.Item key="1" style={{cursor: 'auto'}}>
                  //   <SearchInput mode={mode} isMobile={isMobile} />
                  // </Menu.Item>
                }
              </Menu>
            </div>
          )}
          <div className="nav-right">
          <Text className="font-size-lg">
              {/* <MedicineBoxOutlined /> */}
          </Text>
          <Link to={`${APP_PREFIX_PATH}/SettingsApp`}>
            {organization?.name
              ?<Text className="font-size-lg font-weight-semibold pl-3 text-truncate">
               {organization.name} /
            </Text>
            :null
            }
          </Link>
            {
              location?.name ? 
                <Dropdown overlay={locationList} placement="bottomRight" disabled = {locations === null}>
                  <div className="cursor-pointer" onClick={e => e.preventDefault()}>
                    <span className="text-primary ant-dropdown-link font-size-lg font-weight-semibold text-truncate ml-1">{location.name}</span><CaretDownFilled />
                  </div>
                </Dropdown>
               : null
            }
          
            {/* <NavNotification />
            <NavLanguage /> */}
            <NavProfile />
            {/* <NavPanel /> */}
          </div>
            <NavSearch active={searchActive} close={onSearchClose} />
        </div>
      </div>
    </Header>
  )
}

const mapStateToProps = ({ theme, main }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav } =  theme;
  const { organization, location, locations } = main
  return { navCollapsed, navType, headerNavColor, mobileNav, organization, location, locations }
};

const mapDispatchToProps = {
  changeLocation,
  toggleCollapsedNav, 
  onMobileNavToggle
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNav);